import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
} from "@insite/client-framework/HandlerCreator";
import { GetProductCollectionApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import loadProductInfoList from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";

export interface Parameter {
    productIds: string[];
}

type HandlerType = ApiHandlerDiscreteParameter<Parameter, GetProductCollectionApiV2Parameter>;

export const PrepareParameter: HandlerType = async props => {
    props.apiParameter = {
        productIds: props.parameter.productIds,
        pageSize: 8,
    }
};

export const CallProductDetails: HandlerType = props => {
    props.dispatch(
        loadProductInfoList({
            id: "vmiProductInfo",
            getProductCollectionParameter: props.apiParameter,
            forceLoad: true,
        })
    )
};

export const chain = [PrepareParameter, CallProductDetails];

const loadVmiProductInfo = createHandlerChainRunner(chain, "LoadVmiProductInfoList");
export default loadVmiProductInfo;